import {AbstractControl, FormControl, ValidationErrors, Validators} from "@angular/forms";

export class EmailValidator {

	static validateEmail(email: string) {
		return EmailValidator.validate(new FormControl(email));
	}

	static validate(control: AbstractControl): ValidationErrors | null {
		if (control.value != null && (control.value instanceof String || typeof control.value === 'string')) {
			const baseEmailValidatorErrors = Validators.email(control);
			if (baseEmailValidatorErrors != null) {
				return baseEmailValidatorErrors;
			} else {
				return EmailValidator.customValidation(control.value);
			}
		}
		return null;
	}

	private static customValidation(emailParameter: any): ValidationErrors | null {
		const emailString: string = emailParameter as string;
		const lastDotIndex = emailString.lastIndexOf(".");
		const lastAtIndex = emailString.lastIndexOf("@");
		const domain = emailString.slice(lastDotIndex + 1, emailString.length);

		if (lastDotIndex < 0 || lastAtIndex > lastDotIndex || domain.length < 2 || domain.length > 10 || /\d/.test(domain)) {
			return {
				email: 'wrong email'
			} as ValidationErrors;
		}
		if (emailString.indexOf("/") >= 0 || emailString.indexOf("%") >= 0) {
			return {
				email: 'wrong email'
			} as ValidationErrors;
		}
		return null;
	}

}
